import React, { useState } from 'react';
import { Container, Stack } from '@mui/material';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { InviteCustomerForm } from '../../../../components/invite-customer-form';

export const CreateCustomerScreen = () => {
    return (
        <Page title="POM Safe - Invite Customers">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Invite Customers"
                        links={[
                            {
                                name: 'Customers',
                                href: '/customers'
                            },
                            {
                                name: 'Invite',
                                href: '/customers/create'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <InviteCustomerForm />
            </Container>
        </Page>
    )
}